import { IOpenFoodFactMealPayload } from "model/food/types/mealPayload.types"
import getBaseMealPayloadFromFood from "./getBaseMealPayloadFromFood"
import { getImagePayload } from "./getImagePayload"
import { LogMealType } from "model/food/types/base.types"
import { IOpenFoodFactFood } from "model/food/types/openFoodFact.types"

export const getOpenFoodFactMealPayloadFromFood = (
  food: IOpenFoodFactFood,
  mealType?: LogMealType,
) => {
  const payload: IOpenFoodFactMealPayload = {
    ...getBaseMealPayloadFromFood(food),
    ...getImagePayload(food),
    type: mealType,
    source: "OPEN_FOOD_FACTS",
    brand: food.brand,
  }

  return payload
}
